import React from 'react';
import {Link} from 'react-router-dom';
import ReactTable from 'react-table';
import {Editor} from '../editor-components';
import FontAwesome from 'react-fontawesome';
import firebase from 'firebase/app';
import 'firebase/database';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import CreateBoothDialog from './create-booth-dialog';

/** @class BoothList
  * A component which lists booths available to edit.
  */
export default class BoothList extends ReactFireComponent {
  /** @constructor
    * Constructs a new BoothList instance
    */
  constructor(props) {
    super(props);
    this.state = {booths:[], showNewDialog: false}
    var expoID = this.props.match.params.expoID
    var showID = this.props.match.params.showID
    this.dataURL = `/expos/${expoID}/shows/${showID}/booths`;
    this.hallURL = `/expos/${expoID}/shows/${showID}/halls`;
    this.toggleNewDialog = this.toggleNewDialog.bind(this);
    this.handleNewBooth = this.handleNewBooth.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to the corresponding data
    * in the Firebase realtime database.
    */
  componentWillMount() {
    this.bindAsArray(this.dataURL, 'booths');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the Firebase database.
    */
  componentWillUnmount() {
    this.unbind('booths');
  }
  toggleNewDialog() {
    this.setState({showNewDialog: !this.state.showNewDialog});
  }
  /** @function handleNewBooth
    * Creates a new booth.
    */
  handleNewBooth(){
    const newBooth = {
      metadata: {
        name: "New Booth",
        published: false
      },
      halls: {},
      contents: {}
    };
    firebase.database().ref(this.dataURL).push(newBooth);
  }
  /** @function handleRemove
    * Deletes the specified booth from the booth list,
    * any halls it belongs to, and any media uploaded
    * to firebase storage
    * @param {Object} booth - the booth to remove
    */
  handleRemove(boothID){
    var booth = this.state.booths.find(booth => booth.id === boothID);
    if(booth && window.confirm("Are you sure? This will permanently remove the booth")) {
      var updates = {
        // remove the booth
        [`${this.dataURL}/${booth.id}`]: null
      }
      Object.keys(booth.halls || {}).forEach(hallID => {
        // remove the hall entry for the booth
        updates[`${this.hallURL}/${hallID}/booths/${booth.id}`] = null;
      });
      firebase.database().ref().update(updates, () => {
        // TODO: Remove booth assets from storage
        // Need to iterate through matching items
        //firebase.storage().ref().child(`${this.dataURL}/${booth.id}`)
        //.delete().catch(err => {
        //  console.error(err);
        //});
      });
    }
  }
  /** @function render
    * Renders the component.
    */
  render() {
    const columns = [
      {Header: 'Booth', accessor: 'metadata.name'},
      {Header: 'Halls', accessor: 'halls', Cell: (row) => (
        Object.values(row.value || {}).join(', ')
      )},
      {Header: 'Builders', accessor: 'builders', Cell: (row) => (
        Object.values(row.value || {}).join(', ')
      )},
      {Header: 'Status', accessor: 'metadata.status', Cell: (row) => {
        switch(row.value) {
          case 'Unassigned':
            return <span style={{color: 'red'}}>{row.value}</span>
          case 'Assigned':
            return <span style={{color: 'orange'}}>{row.value}</span>
          case 'In Progress':
            return <span style={{color: 'purple'}}>{row.value}</span>
          case 'Ready for Review':
            return <span style={{color: 'blue'}}>{row.value}</span>
          case 'Approved':
            return <span style={{color: 'green'}}>{row.value}</span>
          default:
            return <span>{row.value}</span>
        }
      }},
      {Header: 'Action', accessor: 'id', Cell: (row) => (
        <div className="centered-text">
          <Link to={`${this.dataURL}/${row.value}`} >
            <FontAwesome name="edit" style={{color: 'orange', cursor: 'pointer'}} />
          </Link>
          <FontAwesome name="times"
            style={{color: "red", cursor: "pointer"}}
            onClick={() => this.handleRemove(row.value)}
            />
        </div>
      )}
    ]
    return (
      <Editor>
        <CreateBoothDialog
          show={this.state.showNewDialog}
          onExit={this.toggleNewDialog}
          expoID={this.props.match.params.expoID}
          showID={this.props.match.params.showID}
          />
        <button className="btn btn-success" onClick={this.toggleNewDialog}>
          <FontAwesome name="plus"/>
          Add New Booth
        </button>
        <ReactTable
          data={this.state.booths}
          columns={columns}
          className="-striped"
          filterable
          defaultPageSize={15}/>
      </Editor>
    );
  }
}



// WEBPACK FOOTER //
// ./src/booth-list/booth-list.js